module.exports = __webpack_public_path__ + "assets/ErectPerpDetailed.89224590ee4043cd9b205103ed87e3f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/ErectPerpDetailed.png
// module id = 513
// module chunks = 0